import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const kakao: Platform = {
  id: 'kakao',
  name: 'KakaoStory',
  iconIndex: PlatformRegistry.kakao.index,
  color: PlatformRegistry.kakao.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://story.kakao.com/s/share', {
      url: content.url,
    });
  },
};

